import { bO as H, aP as K, bP as G, aS as Z, bQ as ee, aJ as te, b6 as ne, aR as re, bL as ie, bC as oe } from "../shared/useDomainIdpMapping.js";
import { aL as Be, aO as Me, aQ as De, a_ as Qe, ak as Fe, bR as je, bf as We, aA as $e, bg as ze, bm as Je, az as Ve } from "../shared/useDomainIdpMapping.js";
import { useCallback as v, useState as A, useEffect as P, useRef as M } from "react";
import { useAuth as _, AuthProvider as ae } from "react-oidc-context";
import { jsx as r, jsxs as g, Fragment as se } from "react/jsx-runtime";
import { Button as y } from "primereact/button";
import { UserManager as ce } from "oidc-client-ts";
import { PrimeReactProvider as ue } from "primereact/api";
function q() {
  const e = _(), n = v(
    (i = {}) => H(e, i),
    [e]
  ), t = v(() => e.signoutRedirect(), [e]);
  return { signIn: n, signOut: t };
}
function Q({
  connection: e,
  returnTo: n,
  label: t = "Sign in",
  icon: i = "pi pi-sign-in",
  ...a
}) {
  const { signIn: s } = q();
  return /* @__PURE__ */ r(
    y,
    {
      type: "button",
      label: t,
      icon: i,
      ...a,
      onClick: () => {
        s({ connection: e, returnTo: n });
      }
    }
  );
}
function Oe({
  label: e = "Sign out",
  icon: n = "pi pi-sign-out",
  ...t
}) {
  const { signOut: i } = q();
  return /* @__PURE__ */ r(
    y,
    {
      type: "button",
      label: e,
      icon: n,
      ...t,
      onClick: () => {
        i();
      }
    }
  );
}
function F(e) {
  try {
    const t = new URL(e).pathname.split("/").filter(Boolean);
    return t.length > 0 ? t[t.length - 1] : null;
  } catch {
    return null;
  }
}
const le = "oidc.", de = "si:p";
function me() {
  if (typeof window > "u")
    return null;
  const e = new URLSearchParams(window.location.search);
  if (e.has("code") || e.has("error"))
    return e;
  const n = new URLSearchParams(window.location.hash.replace(/^#/, ""));
  return n.has("code") || n.has("error") ? n : null;
}
function fe(e) {
  try {
    const n = decodeURIComponent(e).split(";", 1)[0], t = window.localStorage.getItem(`${le}${n}`);
    return t ? JSON.parse(t).request_type === de : !1;
  } catch {
    return !1;
  }
}
function j() {
  const e = me(), n = e == null ? void 0 : e.get("state");
  return !!(typeof window < "u" && window.opener && n && fe(n));
}
async function he(e) {
  return j() ? (await new ce(e).signinPopupCallback(), !0) : !1;
}
const pe = 600 * 1e3, W = 120 * 1e3;
function ge() {
  return typeof window < "u" ? window.location.origin : "";
}
function $({
  authority: e,
  clientId: n,
  redirectUri: t,
  scopes: i
}) {
  return {
    authority: e,
    client_id: n,
    redirect_uri: t,
    metadataUrl: `${e}/.well-known/openid-configuration`,
    response_type: "code",
    // Least privilege by default: authentication only. Apps that use the Admin
    // UI must opt into Admin API scopes (e.g. `CLIQUE_SCOPES.all` or `cliqueScopes({...})`).
    scope: i ?? K.authOnly
  };
}
function Se({
  nearExpiryWindowMs: e = W,
  ...n
}) {
  const t = $(n);
  return {
    ...t,
    post_logout_redirect_uri: t.redirect_uri,
    popup_redirect_uri: t.redirect_uri,
    automaticSilentRenew: !1,
    // Authifi puts `resource_roles` / `groups` on userinfo, not the ID token
    // (`conformIdTokenClaims`). oidc-client-ts 3 defaults this to false.
    loadUserInfo: !0,
    accessTokenExpiringNotificationTimeInSeconds: e / 1e3,
    onSigninCallback: (i) => {
      const a = i == null ? void 0 : i.state, s = G(a == null ? void 0 : a.returnTo);
      window.history.replaceState({}, document.title, s);
    }
  };
}
const be = /(?:^|\s)auth\./;
function Ce(e) {
  return e.apiBaseUrl != null || e.resourceServer != null;
}
function ve(e) {
  var a;
  const n = !!e.apiBaseUrl, t = !!e.resourceServer;
  if (n !== t)
    throw new Error(
      "CliqueAuthProvider admin mode requires both apiBaseUrl and resourceServer. Omit both for authentication-only, or pass both to mount CliqueProvider."
    );
  if (!n || !t)
    return;
  const i = ((a = e.scopes) == null ? void 0 : a.trim()) ?? "";
  if (!i)
    throw new Error(
      "CliqueAuthProvider admin mode requires an explicit scopes value. Pass scopes={CLIQUE_SCOPES.all} or scopes={cliqueScopes({...})}."
    );
  if (!be.test(i))
    throw new Error(
      "CliqueAuthProvider admin mode requires Admin API scopes (auth.*). CLIQUE_SCOPES.authOnly is authentication-only and will 403. Pass CLIQUE_SCOPES.all or cliqueScopes({...})."
    );
  if (!(e.tenantId || F(e.authority)))
    throw new Error(
      "CliqueAuthProvider admin mode requires a tenantId or an authority URL with a tenant path."
    );
}
function Pe({
  connectionRef: e
}) {
  var a, s;
  const n = _(), { data: t } = ie(), { data: i } = oe(((s = (a = n.user) == null ? void 0 : a.profile) == null ? void 0 : s.email) ?? "");
  return P(() => {
    const d = (t == null ? void 0 : t.providerName) || (i == null ? void 0 : i.confidence) === "high" && i.recommendedProvider || void 0;
    e.current = d || void 0;
  }, [t, i, e]), null;
}
function Ee() {
  return /* @__PURE__ */ r("div", { className: "flex items-center justify-center h-screen bg-[var(--clique-bg-subtle)]", children: /* @__PURE__ */ g("div", { className: "text-center max-w-sm", children: [
    /* @__PURE__ */ r("h1", { className: "text-3xl font-bold mb-2 text-[var(--clique-fg)]", children: "Sign in" }),
    /* @__PURE__ */ r("p", { className: "mb-8 text-[var(--clique-fg-secondary)]", children: "Continue to your account" }),
    /* @__PURE__ */ r(Q, { className: "w-full" })
  ] }) });
}
function we() {
  return /* @__PURE__ */ r("div", { className: "flex items-center justify-center h-screen bg-[var(--clique-bg-subtle)]", children: /* @__PURE__ */ g("div", { className: "text-center max-w-md", children: [
    /* @__PURE__ */ r(
      "i",
      {
        "aria-hidden": "true",
        className: "pi pi-exclamation-triangle text-4xl text-[var(--clique-destructive)]"
      }
    ),
    /* @__PURE__ */ r("h2", { className: "text-xl font-semibold mt-4 mb-2 text-[var(--clique-fg)]", children: "Authentication Error" }),
    /* @__PURE__ */ r("p", { className: "mb-4 text-[var(--clique-fg-secondary)]", children: "We couldn't complete sign-in. Please try again." }),
    /* @__PURE__ */ r(Q, { label: "Sign In" })
  ] }) });
}
function D() {
  return /* @__PURE__ */ r("div", { className: "flex items-center justify-center h-screen bg-[var(--clique-bg-subtle)]", children: /* @__PURE__ */ g("div", { className: "text-center", children: [
    /* @__PURE__ */ r(
      "i",
      {
        "aria-hidden": "true",
        className: "pi pi-spin pi-spinner text-4xl text-[var(--clique-primary)]"
      }
    ),
    /* @__PURE__ */ r("p", { className: "mt-4 text-[var(--clique-fg-secondary)]", children: "Loading..." })
  ] }) });
}
function Ie({ onRetry: e }) {
  return /* @__PURE__ */ r(
    "div",
    {
      role: "alert",
      className: "flex items-center justify-center h-screen bg-[var(--clique-bg-subtle)]",
      children: /* @__PURE__ */ g("div", { className: "text-center max-w-md", children: [
        /* @__PURE__ */ r("h2", { className: "text-xl font-semibold mb-2 text-[var(--clique-fg)]", children: "Authentication Error" }),
        /* @__PURE__ */ r("p", { className: "mb-4 text-[var(--clique-fg-secondary)]", children: "We couldn't complete sign-in. Please try again." }),
        /* @__PURE__ */ r(y, { type: "button", label: "Try again", onClick: e })
      ] })
    }
  );
}
function Ae(e) {
  var x, U, R, N;
  const {
    authority: n,
    tenantId: t,
    renderSignIn: i,
    idleTimeoutMs: a = pe,
    nearExpiryWindowMs: s = W,
    enableSessionDiagnostics: d = !1,
    children: u
  } = e, o = _(), { signIn: S } = q(), m = M(void 0), b = M((x = o.user) == null ? void 0 : x.access_token);
  b.current = (U = o.user) == null ? void 0 : U.access_token;
  const f = t || F(n) || "", h = Ce(e), p = h ? e.apiBaseUrl : void 0, l = "queryClient" in e ? e.queryClient : void 0, c = o.isAuthenticated ? (N = (R = o.user) == null ? void 0 : R.profile) == null ? void 0 : N.sub : void 0, [z, J] = A(c), E = h && z !== c;
  P(() => {
    E && (l && (l.cancelQueries(), l.clear()), J(c));
  }, [c, l, E]), P(() => {
    o.error && (console.error("Authentication error", o.error), typeof window < "u" && /[?&](?:code|error)=/.test(window.location.search) && window.history.replaceState({}, document.title, ee()));
  }, [o.error]);
  const V = v(() => b.current, []), X = v(
    (w) => {
      var L, B;
      const O = m.current, T = (B = (L = o.user) == null ? void 0 : L.profile) == null ? void 0 : B.email, k = w.acrValues ?? te, Y = {
        acr_values: k,
        popupAbortOnClose: !0,
        ...w.maxAge != null ? { max_age: w.maxAge } : {},
        extraQueryParams: {
          resource: `${p ?? ""}/auth/${f}`,
          acr_values: k,
          ...O ? { connection: O } : {},
          ...T ? { login_hint: T } : {}
        }
      };
      return o.signinPopup(Y).then((I) => {
        if (I && typeof I.access_token == "string")
          return I;
        throw new Error("Popup closed");
      });
    },
    [p, o, f]
  );
  return o.isLoading && !o.activeNavigator ? /* @__PURE__ */ r(D, {}) : o.error && o.error.source !== "signinPopup" && o.error.source !== "signinSilent" ? /* @__PURE__ */ r(we, {}) : o.isAuthenticated ? E ? /* @__PURE__ */ r(D, {}) : /* @__PURE__ */ r(
    ne,
    {
      idleTimeoutMs: a,
      nearExpiryWindowMs: s,
      enableDiagnostics: d,
      children: h ? /* @__PURE__ */ g(
        re,
        {
          baseURL: e.apiBaseUrl,
          tenantId: f,
          getAccessToken: V,
          queryClient: l,
          resourceServer: e.resourceServer,
          labels: e.labels,
          defaultIdentityIssuer: e.defaultIdentityIssuer,
          invitationApprove: e.invitationApprove,
          userCreate: e.userCreate ? { ...e.userCreate, clientId: e.clientId } : void 0,
          suppressForbiddenToast: e.suppressForbiddenToast,
          gateComponents: e.gateComponents,
          namespaceId: e.namespaceId,
          onLoginRequired: () => void S(),
          onStepUpRequired: X,
          children: [
            /* @__PURE__ */ r(Pe, { connectionRef: m }),
            u
          ]
        }
      ) : u
    }
  ) : i ? /* @__PURE__ */ r(se, { children: i({ signIn: S }) }) : /* @__PURE__ */ r(Ee, {});
}
let C = null;
function Te(e) {
  ve(e);
  const {
    authority: n,
    clientId: t,
    redirectUri: i,
    scopes: a,
    nearExpiryWindowMs: s,
    theme: d
  } = e, u = i ?? ge(), o = j(), [S, m] = A(!1), [b, f] = A(0);
  if (P(() => {
    !o || C || (C = he(
      $({ authority: n, clientId: t, redirectUri: u, scopes: a })
    ), C.catch((c) => {
      C = null, console.error("OIDC popup callback failed", c), m(!0);
    }));
  }, [o, n, t, u, a, b]), o)
    return S ? /* @__PURE__ */ r(
      Ie,
      {
        onRetry: () => {
          m(!1), f((c) => c + 1);
        }
      }
    ) : null;
  const h = Se({
    authority: n,
    clientId: t,
    redirectUri: u,
    scopes: a,
    nearExpiryWindowMs: s
  }), p = /* @__PURE__ */ r(Ae, { ...e, redirectUri: u }), l = d ? /* @__PURE__ */ r(Z, { ...d, children: p }) : p;
  return /* @__PURE__ */ r(ae, { ...h, children: /* @__PURE__ */ r(ue, { children: l }) });
}
export {
  Be as ADMIN_PERMISSIONS_UPDATE_SCOPE,
  Me as CLIQUE_BASE_SCOPES,
  K as CLIQUE_SCOPES,
  De as CLIQUE_SCOPE_NAMES,
  Te as CliqueAuthProvider,
  pe as DEFAULT_SESSION_IDLE_TIMEOUT_MS,
  W as DEFAULT_TOKEN_NEAR_EXPIRY_WINDOW_MS,
  Qe as NAMESPACE_LIST_SCOPE_REQUIREMENT,
  Q as SignInButton,
  Oe as SignOutButton,
  Fe as allowsNamespaceList,
  ve as assertCliqueAuthConfig,
  $ as buildOidcBaseSettings,
  Se as buildOidcConfig,
  ee as buildReturnTo,
  je as buildSigninArgs,
  We as cliqueFeatureScope,
  $e as cliqueFeatureScopes,
  ze as cliqueScopes,
  H as cliqueSignIn,
  he as completeOidcPopupCallback,
  ge as defaultRedirectUri,
  F as extractTenantFromAuthority,
  Ce as isCliqueAuthAdminConfig,
  j as isOidcPopupCallback,
  Je as parseScopeClaim,
  G as sanitizeReturnTo,
  Ve as satisfiesScopeRequirement,
  q as useCliqueSignIn
};
//# sourceMappingURL=index.js.map
